import { Component } from "@angular/core";
import { Router } from "@angular/router";
import * as CryptoJS from "crypto-js";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.css"],
})
export class MyAccountComponent {
  userInfo: any;
  socialMediaUser: boolean;
  constructor(private router: Router) {
    if (localStorage.getItem(environment.localStorageKey)) {
      this.userInfo = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem(environment.localStorageKey),
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );
      this.socialMediaUser = this.userInfo.socialMediaUser;
    }
    else {
      this.router.navigate(["/login"]);
    }

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1000);
  }


}
